import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';

import { EmptyState } from './EmptyState';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    emptyMessage: {
      borderTop: '1px solid rgba(0, 0, 0, 0.25)',
      display: 'inline-block',
      height: '80%',
      marginTop: 0,
      padding: `${unit * 3}px ${unit * 3 + 4}px`,
      width: '100%',
    },
  });

interface EmptyStateListChatActivitiesProps extends WithStyles<typeof styles> {
  selectedTab: 'myChats' | 'unassigned' | 'assigned' | 'closed';
  filtering?: boolean;
  hasFiltersApplied?: boolean;
}

const EmptyStateListChatActivities: React.FC<EmptyStateListChatActivitiesProps> = ({
  classes,
  selectedTab,
  filtering,
  hasFiltersApplied,
}) => {
  let icon = '';
  let title = '';
  let subtitle = '';

  if (!filtering) {
    if (hasFiltersApplied) {
      switch (selectedTab) {
        case 'unassigned':
          icon = ':eyes:';
          title = `0 ${selectedTab} chats`;
          subtitle = 'Some chats might be filtered out. Clear filters to see all unassigned chats.';
          break;
        default:
          icon = ':eyes:';
          title = `0 ${selectedTab !== 'myChats' ? selectedTab : ''} chats`;
          subtitle = 'Clear or update your filters for new results.';
      }
    } else {
      switch (selectedTab) {
        case 'myChats':
          icon = ':tada:';
          title = 'Yay, your chat queue is empty!';
          subtitle = '0 chats have been assigned to you.';
          break;
        case 'unassigned':
          icon = ':raised_hands:';
          title = '0 unassigned chats';
          subtitle = `If a patient opens a new chat with your organization, it'll appear here.`;
          break;
        case 'assigned':
          icon = ':unicorn:';
          title = '0 assigned chats (that’s a rare sight)';
          subtitle = 'You can view any of your team’s active conversations here.';
          break;
        case 'closed':
          icon = ':closed_book:';
          title = '0 closed chats';
          subtitle = 'You can view any closed conversations here.';
          break;
        default:
      }
    }
  } else {
    icon = ':mag:';
    title = '0 patients have been found.';
    subtitle = '';
  }

  return (
    <div className={classes.emptyMessage}>
      <EmptyState icon={icon} subtitle={subtitle} title={title} />
    </div>
  );
};

export default withStyles(styles)(EmptyStateListChatActivities);
